/**
 * Created by koqiui on 2017-04-09.
 */
import { Jqext, Utils } from '../../app.base';
import { MsgBox, Routes, Vue } from '../../app.vues';

import SwbComBizParamListSelect from './ComBizParamList';
Vue.regist(SwbComBizParamListSelect);

export function showComBizParamDlg(realComId) {
    Vue.$showDialog({
        title: "实体公司-业务参数",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        template: '<swb-com-biz-param-list :realComId="realComId" ref="swb_real_com_select"></swb-com-biz-param-list>',
        data: {
            realComId: realComId
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/bizParam/dialog.js
// module id = 1561
// module chunks = 1